import { H1 } from '@atoms/Typographies';
import { DashboardForm } from '@organisms/GenesisEs/Forms';
import { DashboardFormType, FormDate } from '@organisms/GenesisEs/Forms/DashboardFormType';
import { CardClose, CardOpen, Cards, Container } from '@organisms/GenesisEs/Layouts';
import { Close, CloseRent, Open, OpenRent } from '@organisms/GenesisEs/Totalization';
import Head from '@organisms/Heads/Head';
import { Storage } from '@states/Storage';
import CommonTemplate from '@templates/Common';
import { format } from 'date-fns';
import React, { useState } from 'react';
import styled from 'styled-components';


const getLabelFromSearchDate = (searchDate: FormDate) => {
    const formatString = 'yyyy-MM-dd';
    const date = new Date();
    const today = format(date, formatString);
    date.setDate(date.getDate() - 1);
    const yesterday = format(date, formatString);
    if (searchDate.start === searchDate.end) {
        if (searchDate.start === today) {
            return '本日';
        }
        if (searchDate.start === yesterday) {
            return '昨日';
        }
        return '【' + dateFormatForLabel(searchDate.start) + '】';
    }
    return '【' + dateFormatForLabel(searchDate.start) + '-' + dateFormatForLabel(searchDate.end) + '】';
};

const dateFormatForLabel = (date: string | undefined) => {
    return (date || '').replaceAll('-', '.');
};

const Top = () => {
    const [searchParams, setSearchParams] = useState<DashboardFormType>(Storage.get(Storage.keys.GENESISES_DASHBOARD));
    const submitHandler = (data:any) => {
        setSearchParams(data);
    };
    const label = getLabelFromSearchDate(searchParams.date);

    return (
        <CommonTemplate>
            <Head title='ダッシュボード' />
            
            <HeadingWithStyled className='mb-4'>
                <H1>ダッシュボード</H1>
            </HeadingWithStyled>
            
            <Container title='Search' children={<DashboardForm submitHandler={submitHandler} />} />
            
            <Cards>
                <CardOpen title={`${label}の再点件数`} children={<Open />} />
                <CardOpen title={`${label}の再点（賃貸）件数`} children={<OpenRent />} />
                <CardClose title={`${label}の廃止件数`} children={<Close />} />
                <CardClose title={`${label}の廃止（賃貸）件数`} children={<CloseRent />} />
            </Cards>
            
        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`

export default Top;
